import { DataSourceArray } from 'photoswipe'
import { GalleryProps } from 'react-photoswipe-gallery'

const onInitThumbnails = (el, pswpInstance) => {
  let prevIndex = -1
  const thumbnails: HTMLElement[] = []

  el.style.position = 'absolute'
  el.style.bottom = '20px'
  el.style.left = '10px'
  el.style.right = '0'
  el.style.display = 'grid'
  el.style.gridGap = '10px'
  el.style.gridTemplateColumns = 'repeat(auto-fit, 40px)'
  el.style.gridTemplateRows = 'repeat(auto-fit, 40px)'
  el.style.justifyContent = 'center'

  const dataSource = pswpInstance.options.dataSource as DataSourceArray

  for (let i = 0; i < dataSource.length; i++) {
    const slideData = dataSource[i]

    const thumbnail = document.createElement('div')
    thumbnail.style.transition = 'transform 0.15s ease-in'
    thumbnail.style.opacity = '0.6'
    thumbnail.style.cursor = 'pointer'
    thumbnail.onclick = (e: MouseEvent) => {
      const target = e.target as HTMLImageElement | HTMLDivElement
      const thumbnailEl =
        target.tagName === 'IMG' ? target.parentElement : (e.target as HTMLImageElement | HTMLDivElement)
      pswpInstance.goTo(thumbnails.indexOf(thumbnailEl))
    }

    const thumbnailImage = document.createElement('img')
    thumbnailImage.setAttribute('src', slideData.msrc)
    thumbnailImage.style.width = '100%'
    thumbnailImage.style.height = '100%'
    thumbnailImage.style.objectFit = 'cover'
    thumbnailImage.style.border = '1px solid #fff'

    thumbnail.appendChild(thumbnailImage)

    el.appendChild(thumbnail)

    thumbnails.push(thumbnail)
  }

  pswpInstance.on('change', () => {
    if (prevIndex >= 0) {
      const prevThumbnail = thumbnails[prevIndex]
      prevThumbnail.style.opacity = '0.6'
      prevThumbnail.style.cursor = 'pointer'
      prevThumbnail.style.transform = 'scale(1)'
    }

    const currentThumbnail = thumbnails[pswpInstance.currIndex]
    currentThumbnail.style.opacity = '1'
    currentThumbnail.style.cursor = 'unset'
    currentThumbnail.style.transform = 'scale(1.2)'

    prevIndex = pswpInstance.currIndex
  })
}

export const getLightboxUiElements = (): GalleryProps['uiElements'] => [
  {
    name: 'bulletsIndicator',
    order: 9,
    isButton: false,
    appendTo: 'wrapper',
    onInit: onInitThumbnails,
  },
]
